const NEXT_API_BASE = `${process.env.NEXT_PUBLIC_SITE_URL}/next-api` as string;

export default NEXT_API_BASE;
